import React, { useEffect, useState } from 'react';
import { documentTypeServices } from '../../../APIServices/documentTypeServices';
import Pagination from '../../../hooks/Pagination';
import AddNewDocumentType from './AddNewDocumentType';
import UpdateDocumentType from './UpdateDocumentType';
import DeleteDocumentType from './DeleteDocumentType';
import DeletedDocumentTypeHistory from './DeletedDocumentTypeHistory';

function DocumentTypeManagement() {
  const [documentTypeList, setDocumentTypeList] = useState([]);
  const [documentTypeCount, setDocumentTypeCount] = useState(0);
  const [deleteDocumentTypeList, setDeleteDocumentTypeList] = useState([]);
  const [deleteDocumentTypeCount, setDeleteDocumentTypeCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState('');
  const [confirm, setConfirm] = useState(false);
  const [documentTypeData, setDocumentTypeData] = useState('');
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const totalPage = Math.ceil(documentTypeCount / itemsPerPage);
  const [deletedPageNumber, setDeletedPageNumber] = useState(1);
  const [deletedItemsPerPage, setDeletedItemsPerPage] = useState(10);

  const getDocumentTypeData = async () => {
    setLoading(true);
    const data = await documentTypeServices.getDocumentTypeData('active', '', pageNumber, itemsPerPage);
    setDocumentTypeList(data?.data || []);
    setDocumentTypeCount(data?.count || 0);
    setLoading(false);
  };

  const getDeletedDocumentTypeData = async () => {
    setLoading(true);
    const data = await documentTypeServices.getDocumentTypeData('deleted', '', deletedPageNumber, deletedItemsPerPage);
    setDeleteDocumentTypeList(data?.data || []);
    setDeleteDocumentTypeCount(data?.count || 0);
    setLoading(false);
  };

  useEffect(() => {
    getDocumentTypeData();
  }, [pageNumber, itemsPerPage]);

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-eyebrow">Workspace metadata</div>
          <h1 className="page-title">Document Type Management</h1>
          <p className="page-sub">
            Create, update, and manage document types used across workspace metadata and document classification.
          </p>
        </div>
      </div>

      <div className="flex between center mb-3">
        <div className="section-label">
          Document Types <span className="count">{documentTypeCount}</span>
        </div>

        <div className="hstack gap-4">
          <button className="btn btn-primary" onClick={() => setModalOpen('add')}>
            <i className="ti ti-plus" />
            Add Document Type
          </button>
          <button className="btn btn-danger" onClick={() => setModalOpen('deletedHistiory')}>
            <i className="ti ti-history" />
            Deleted History
          </button>
        </div>
      </div>

      <div className="card">
        {loading ? (
          <div style={{ padding: 40, textAlign: 'center' }}>
            <div className="buttonLoader" />
            <div style={{ marginTop: 12 }}>Loading document types...</div>
          </div>
        ) : documentTypeCount === 0 ? (
          <div style={{ padding: 24, textAlign: 'center', color: 'var(--ink-3)' }}>
            <i className="ti ti-file-description" style={{ fontSize: 24, display: 'block', marginBottom: 8 }} />
            No Document Type. Click "Add Document Type" to create one.
          </div>
        ) : (
          <>
            <table className="tbl">
              <thead>
                <tr>
                  <th>Document Type</th>
                  <th style={{ width: 120 }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {documentTypeList.map((item) => (
                  <tr key={item._id}>
                    <td className="medium">{item.documentType}</td>
                    <td>
                      <div className="flex gap-2">
                        <button
                          className="icon-btn"
                          title="Edit"
                          style={{ color: 'var(--info)' }}
                          onClick={() => {
                            setModalOpen('update');
                            setDocumentTypeData(item);
                          }}
                        >
                          <i className="ti ti-edit" />
                        </button>
                        <button
                          className="icon-btn"
                          title="Delete"
                          style={{ color: 'var(--danger)' }}
                          onClick={() => {
                            setModalOpen('delete');
                            setDocumentTypeData(item);
                          }}
                        >
                          <i className="ti ti-trash" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <Pagination
              itemsPerPage={itemsPerPage}
              setItemsPerPage={setItemsPerPage}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              totalPage={totalPage}
              totalItems={documentTypeCount}
            />
          </>
        )}
      </div>

      {modalOpen === 'add' && (
        <AddNewDocumentType setModalOpen={setModalOpen} getDocumentTypeData={getDocumentTypeData} />
      )}
      {modalOpen === 'update' && (
        <UpdateDocumentType
          documentTypeData={documentTypeData}
          setModalOpen={setModalOpen}
          getDocumentTypeData={getDocumentTypeData}
          setConfirm={setConfirm}
          confirm={confirm}
        />
      )}
      {modalOpen === 'delete' && (
        <DeleteDocumentType
          getDocumentTypeData={getDocumentTypeData}
          getDeletedDocumentTypeData={getDeletedDocumentTypeData}
          setModalOpen={setModalOpen}
          documentTypeData={documentTypeData}
        />
      )}
      {modalOpen === 'deletedHistiory' && (
        <DeletedDocumentTypeHistory
          getDocumentTypeData={getDocumentTypeData}
          getDeletedDocumentTypeData={getDeletedDocumentTypeData}
          setModalOpen={setModalOpen}
          deletedPageNumber={deletedPageNumber}
          setDeletedPageNumber={setDeletedPageNumber}
          deletedItemsPerPage={deletedItemsPerPage}
          setDeletedItemsPerPage={setDeletedItemsPerPage}
          deleteDocumentTypeList={deleteDocumentTypeList}
          deleteDocumentTypeCount={deleteDocumentTypeCount}
        />
      )}
    </div>
  );
}

export default DocumentTypeManagement;